import React, { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { curlocation, pagesState, CurLocationAsync, mySession, checkSessionAsync, GetMyLibraryAsync, myLibs } from './controller';

export function Header() {

    const dispatch = useDispatch();
    const pages_state = useSelector(pagesState);
    const cur_location = useSelector(curlocation);
    const my_Session = useSelector(mySession);
    const my_Libs = useSelector(myLibs);

    useEffect(() => {
        dispatch(CurLocationAsync());
        dispatch(checkSessionAsync());
        dispatch(GetMyLibraryAsync());

        // if(window.location.href === 'https://www.nas.gov.sg/erequest/#/mycart'){
        //     window.location.href = 'https://www.nas.gov.sg/erequest/mycart';
        // }
        // if(window.location.href === 'https://www.stg.nas.gov.sg/erequest-v2/#/mycart'){
        //     window.location.href = 'https://www.stg.nas.gov.sg/erequest-v2/mycart';
        // }

        if(window.location.href.includes("/#/mycart")){
            window.location.href =window.location.href.replace("/#/mycart","/mycart");
        }
    }, []);
    return (
        <section id="Header">
            <div className="container-fluid bg-white">
                <div className="container">
                    <div className="row">
                    {(my_Session && (my_Libs && my_Libs.isMylibsLogin)) && <div className="col-md-12 p-0 ">
                            <nas-header data-appurl="./" className="ng-isolate-scope nlb-comp" data-applogo="./images/naslogo.png" data-compname="nas-header">
                                <ui-menu>
                                    <ui-menu-item data-active="true" data-url="./" data-text="Home"></ui-menu-item>

                                    <ui-menu-item data-url="#" data-text="Submit Request">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./school/disclaimer" data-text="School Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./marriage/disclaimer" data-text="Marriage Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./archival/disclaimer" data-text="Archival Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./picturesg/disclaimer" data-text="Images from National Library, Singapore"></ui-dropdown-item>
                                        </ui-dropdown>

                                    </ui-menu-item>
                                    <ui-menu-item data-url="#" data-text="How-To Guides">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./school/guide" data-text="School Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./marriage/guide" data-text="Marriage Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./archival/guide" data-text="Archival Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./picturesg/guide" data-text="Images from National Library, Singapore"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./faq" data-text="FAQs"></ui-dropdown-item>
                                        </ui-dropdown>

                                    </ui-menu-item>
                                    <ui-menu-item data-url="#" data-text="My Requests">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./requests" data-text="View Requests" ></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./logout" data-text="Logout"></ui-dropdown-item>
                                        </ui-dropdown>
                                    </ui-menu-item>
                                    <ui-menu-item data-url="./mycart" data-text="My Cart"></ui-menu-item>
                                    <ui-menu-item data-url="#" class="myLibs" data-text={my_Libs && my_Libs.isMylibsLogin ? 'Welcome,' + my_Libs.RequestorNameFromLibs : 'Welcome, myLibs'}>
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./requests" data-text="View Requests"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./logout" data-text="Logout"></ui-dropdown-item>
                                        </ui-dropdown>
                                    </ui-menu-item>
                                </ui-menu>
                            </nas-header>
                        </div>}
                        {(my_Session && (my_Libs && !my_Libs.isMylibsLogin)) && <div className="col-md-12 p-0 ">
                            <nas-header data-appurl="./" className="ng-isolate-scope nlb-comp" data-applogo="./images/naslogo.png" data-compname="nas-header">
                                <ui-menu>
                                    <ui-menu-item data-active="true" data-url="./" data-text="Home"></ui-menu-item>

                                    <ui-menu-item data-url="#" data-text="Submit Request">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./school/disclaimer" data-text="School Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./marriage/disclaimer" data-text="Marriage Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./archival/disclaimer" data-text="Archival Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./picturesg/disclaimer" data-text="Images from National Library, Singapore"></ui-dropdown-item>
                                        </ui-dropdown>

                                    </ui-menu-item>
                                    <ui-menu-item data-url="#" data-text="How-To Guides">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./school/guide" data-text="School Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./marriage/guide" data-text="Marriage Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./archival/guide" data-text="Archival Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./picturesg/guide" data-text="Images from National Library, Singapore"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./faq" data-text="FAQs"></ui-dropdown-item>
                                        </ui-dropdown>

                                    </ui-menu-item>
                                    <ui-menu-item data-url="#" data-text="My Requests">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./requests" data-text="View Requests" ></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./logout" data-text="Logout"></ui-dropdown-item>
                                        </ui-dropdown>
                                    </ui-menu-item>
                                    <ui-menu-item data-url="./mycart" data-text="My Cart"></ui-menu-item>
                                </ui-menu>
                            </nas-header>
                        </div>}
                        {!my_Session &&  <div className="col-md-12 p-0 ">
                            <nas-header data-appurl="./" className="ng-isolate-scope nlb-comp" data-applogo="./images/naslogo.png" data-compname="nas-header">
                                <ui-menu>
                                    <ui-menu-item data-active="true" data-url="./" data-text="Home"></ui-menu-item>

                                    <ui-menu-item data-url="#" data-text="Submit Request">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./school/disclaimer" data-text="School Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./marriage/disclaimer" data-text="Marriage Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./archival/disclaimer" data-text="Archival Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./picturesg/disclaimer" data-text="Images from National Library, Singapore"></ui-dropdown-item>
                                        </ui-dropdown>

                                    </ui-menu-item>
                                    <ui-menu-item data-url="#" data-text="How-To Guides">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./school/guide" data-text="School Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./marriage/guide" data-text="Marriage Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./archival/guide" data-text="Archival Records"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./picturesg/guide" data-text="Images from National Library, Singapore"></ui-dropdown-item>
                                            <ui-dropdown-divider></ui-dropdown-divider>
                                            <ui-dropdown-item data-url="./faq" data-text="FAQs"></ui-dropdown-item>
                                        </ui-dropdown>

                                    </ui-menu-item>
  
                                    <ui-menu-item data-url="#" data-text="My Requests">
                                        <ui-dropdown>
                                            <ui-dropdown-item data-url="./login" data-text="View Requests"></ui-dropdown-item>
                                        </ui-dropdown>
                                    </ui-menu-item>
                                    <ui-menu-item data-url="./mycart" data-text="My Cart"></ui-menu-item>
    
                                </ui-menu>
                            </nas-header>
                        </div>}
                    </div>
                </div>
            </div>
            <div className="container-fluid">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 p-0">
                           
                            <nlb-notice class="mt-2"></nlb-notice>
                        </div>
                    </div>
                </div>
            </div>
            {cur_location && cur_location.LocationCode === 'OR' && <div className="container-fluid bg-danger">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center text-light my-4">
                            <p className="font-weight-bold m-0 mb-2" style={{ fontSize: '1.5rem' }}>ARCHIVES DIGITAL VIEWER</p>
                            <p className="m-0">Restricted Access Records</p>
                        </div>
                    </div>
                </div>
            </div>}
            {cur_location && cur_location.LocationCode === 'OP' && <div className="container-fluid bg-light">
                <div className="container">
                    <div className="row">
                        <div className="col-md-12 text-center text-dark my-4">
                            <p className="font-weight-bold m-0 mb-2" style={{ fontSize: '1.5rem' }}>ARCHIVES DIGITAL VIEWER</p>
                            <p className="m-0">Open Access Records</p>
                        </div>
                    </div>
                </div>
            </div>}
        </section>
    );
}


